import { render, staticRenderFns } from "./TextAndPictureQuestion.vue?vue&type=template&id=4903b790&scoped=true"
import script from "./TextAndPictureQuestion.vue?vue&type=script&lang=js"
export * from "./TextAndPictureQuestion.vue?vue&type=script&lang=js"
import style0 from "./TextAndPictureQuestion.vue?vue&type=style&index=0&id=4903b790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4903b790",
  null
  
)

export default component.exports